import React from 'react';

import { pathwayLabel } from '../../constants';
import { formatDue, getPatient } from '../../helpers';
import { Badge } from '../Badge';
import styles from './TaskRow.module.scss';

const TaskRow = ({ task, compact, onSelect, selected }) => {
  if (!task) return null;

  const patient = task?.patient ?? getPatient(task?.patientId);
  const due = task?.due ? formatDue(task.due) : { text: '—', urgent: false };
  const isCritical = task.priority === 'critical';
  const isBlockedOrFlagged = task.status === 'blocked' || task.status === 'flagged';

  return (
    <button
      type="button"
      onClick={() => onSelect?.(task)}
      className={[styles.row, compact ? styles.compact : '', selected ? styles.selected : ''].join(
        ' ',
      )}
    >
      <div
        className={[
          styles.checkBox,
          isCritical ? styles.checkCritical : '',
          isBlockedOrFlagged ? styles.checkFlagged : '',
        ].join(' ')}
      >
        {task.status === 'done' && '✓'}
      </div>
      <div className={styles.main}>
        <div className={styles.titleRow}>
          <span className={styles.title}>{task.title}</span>
          {task.mustHave2026 && (
            <Badge variant="edge" className={styles.edgeBadge}>
              EDGE
            </Badge>
          )}
        </div>
        {task.caption && (
          <div className={`${styles.caption} ${compact ? styles.captionCompact : ''}`}>
            {task.caption}
          </div>
        )}
        {!compact && (
          <div className={styles.metaRow}>
            {patient?.name} → {task.owner}
          </div>
        )}
      </div>
      {!compact && (
        <>
          <div className={styles.statusCell}>
            {task.status === 'blocked' ? (
              <Badge variant="critical">Blocked</Badge>
            ) : task.status === 'flagged' ? (
              <Badge variant="flagged">Flagged</Badge>
            ) : (
              <Badge>{task.status}</Badge>
            )}
          </div>
          <Badge variant="outline">{pathwayLabel[task.pathway]}</Badge>
        </>
      )}
      <span className={`${styles.dueText} ${due.urgent ? styles.dueUrgent : ''}`}>{due.text}</span>
    </button>
  );
};

export default TaskRow;
